import { create } from 'zustand';

export interface PublicConfig {
  clientCacheMaxDays: number;
  pageCacheEnabled: boolean;
  sessionShortTtlHours: number;
  sessionLongTtlDays: number;
  tiersVisible: boolean;
  paymentsEnabled: boolean;
  adsGloballyEnabled: boolean;
  adsBlockerPolicy: 'STATS_ONLY' | 'SOFT_NUDGE' | 'HARD_GATE';
  soundsEnabledByDefault: boolean;
  soundShareTone: string;
  soundNotificationTone: string;
}

const DEFAULTS: PublicConfig = {
  clientCacheMaxDays: 14,
  pageCacheEnabled: true,
  sessionShortTtlHours: 8,
  sessionLongTtlDays: 30,
  tiersVisible: false,
  paymentsEnabled: false,
  adsGloballyEnabled: false,
  adsBlockerPolicy: 'STATS_ONLY',
  soundsEnabledByDefault: true,
  soundShareTone: 'ascending',
  soundNotificationTone: 'three-tone',
};

interface Store {
  config: PublicConfig;
  setConfig: (c: Partial<PublicConfig>) => void;
}

export const usePublicConfig = create<Store>((set) => ({
  config: { ...DEFAULTS },
  setConfig: (c) => set((s) => ({ config: { ...s.config, ...c } })),
}));
